import { ref } from 'vue'
import axios from 'axios'

import {
  requestCreateComment,
  requestDeleteComment,
  requestCreateLikeComment,
  requestDeleteLikeComment,
} from '@/api/feeds'

export default function useTweetData() {
  const commentData = {
    isCreating: ref(false),
  }

  const getCommentList = ({ nextUrl }) => axios.get(nextUrl, { timeout: 15000 })

  const createComment = ({ feedId, content }) => {
    commentData.isCreating.value = true

    return requestCreateComment({
      content,
      feedId,
    })
      .then((response) => {
        commentData.isCreating.value = false
        return response
      })
  }

  const deleteComment = ({ feedId, commentId }) => requestDeleteComment({
    feedId,
    commentId,
  })

  const toggleCommentLike = ({ comment }) => {
    if (comment.liked) {
      return requestDeleteLikeComment({
        feedId: comment.feed_id,
        commentId: comment.id,
      })
    }

    return requestCreateLikeComment({
      feedId: comment.feed_id,
      commentId: comment.id,
    })
  }

  return {
    commentData,
    getCommentList,
    createComment,
    deleteComment,
    toggleCommentLike,
  }
}
